import { combineReducers } from "redux";
import { summaryReducer } from "./summary/summaryReducer";
import { monitoringReducer } from "./monitoring/monitoringReducer";


export const dataReducer = combineReducers({
    summary: summaryReducer,
    monitoring: monitoringReducer,
});
